import { featured } from "@/mocks/home";

export default function FeaturedGrid() {
  return (
    <section id="featured" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col gap-3 border-b border-background-200 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-700">
              02 / EDITOR'S PICKS
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
              本周精选，大小卡混排
            </h2>
          </div>
          <a
            href="#hot"
            className="inline-flex cursor-pointer items-center gap-1 self-start text-sm font-medium text-foreground-700 transition hover:text-primary-700 md:self-auto"
          >
            更多精选
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {featured.map((item) =>
            item.span === "large" ? (
              <article
                key={item.title}
                className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition hover:border-primary-300 md:col-span-2 md:row-span-2"
              >
                <div className="relative h-56 w-full overflow-hidden md:h-auto md:flex-1 md:min-h-[320px]">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} · 91下载资源大全`}
                    className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-primary-600 px-3 py-1 text-[11px] font-medium text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-7 text-foreground-600">{item.desc}</p>
                  <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                    <span className="text-xs text-foreground-500">{item.meta}</span>
                    <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                      查看条目
                      <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </div>
              </article>
            ) : (
              <article
                key={item.title}
                className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition hover:border-primary-300"
              >
                <div className="relative h-36 w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} · 91下载资源大全`}
                    className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-foreground-800">
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-xs leading-6 text-foreground-600">{item.desc}</p>
                  <span className="mt-3 text-[11px] text-foreground-500">{item.meta}</span>
                </div>
              </article>
            ),
          )}
        </div>
      </div>
    </section>
  );
}